"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "falcade": {
    "a4b9c4b1": [{
      "hkey": "0add33ef",
      "slug": "falcade",
      "name": "Falcade",
      "primary": true,
      "skipSearch": false
    }],
    "canes": [{
      "hkey": "0add33ef",
      "slug": "falcade",
      "name": "Falcade",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f9c30329": [{
      "hkey": "0add33ef",
      "slug": "falcade",
      "name": "Falcade",
      "primary": true,
      "skipSearch": false
    }],
    "caverson": [{
      "hkey": "0add33ef",
      "slug": "falcade",
      "name": "Falcade",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "148d184b": [{
      "hkey": "0add33ef",
      "slug": "falcade",
      "name": "Falcade",
      "primary": true,
      "skipSearch": false
    }],
    "cayada": [{
      "hkey": "0add33ef",
      "slug": "falcade",
      "name": "Falcade",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "eb99f34a": [{
      "hkey": "0add33ef",
      "slug": "falcade",
      "name": "Falcade",
      "primary": true,
      "skipSearch": false
    }],
    "costa": [{
      "hkey": "0add33ef",
      "slug": "falcade",
      "name": "Falcade",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4f48a84e": [{
      "hkey": "0add33ef",
      "slug": "falcade",
      "name": "Falcade",
      "primary": true,
      "skipSearch": false
    }],
    "ganz": [{
      "hkey": "0add33ef",
      "slug": "falcade",
      "name": "Falcade",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2a594f84": [{
      "hkey": "0add33ef",
      "slug": "falcade",
      "name": "Falcade",
      "primary": true,
      "skipSearch": false
    }],
    "marmolada": [{
      "hkey": "0add33ef",
      "slug": "falcade",
      "name": "Falcade",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "925695df": [{
      "hkey": "0add33ef",
      "slug": "falcade",
      "name": "Falcade",
      "primary": true,
      "skipSearch": false
    }],
    "molino": [{
      "hkey": "0add33ef",
      "slug": "falcade",
      "name": "Falcade",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2983415a": [{
      "hkey": "0add33ef",
      "slug": "falcade",
      "name": "Falcade",
      "primary": true,
      "skipSearch": false
    }],
    "ronch": [{
      "hkey": "0add33ef",
      "slug": "falcade",
      "name": "Falcade",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "42e55e51": [{
      "hkey": "0add33ef",
      "slug": "falcade",
      "name": "Falcade",
      "primary": true,
      "skipSearch": false
    }],
    "valfreda": [{
      "hkey": "0add33ef",
      "slug": "falcade",
      "name": "Falcade",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "980433f0": [{
      "hkey": "0add33ef",
      "slug": "falcade",
      "name": "Falcade",
      "primary": true,
      "skipSearch": false
    }],
    "villotta": [{
      "hkey": "0add33ef",
      "slug": "falcade",
      "name": "Falcade",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "20a62790": [{
      "hkey": "0add33ef",
      "slug": "falcade",
      "name": "Falcade",
      "primary": true,
      "skipSearch": false
    }],
    "zingari-bassi": [{
      "hkey": "0add33ef",
      "slug": "falcade",
      "name": "Falcade",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;